export default "__VITE_ASSET__QqF8mAzc__"